import React, { useEffect, useReducer, useState } from 'react';
import BackgroundColor from '../../../../shared/email-services/background-color/BackgroundColor';
import PaddingComponent from '../../../../shared/email-services/padding-component/PaddingComponent';
import CustomTextField from '../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { formDataValidate } from '../../../../utils/formUtils';

const DividerComponent = (props) => {
  const {
    componentId,
    subId,
    onItemChange,
    componentObj,
    isRemovable,
    activeNdx,
    onRemoveComponent,
  } = props;

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    color: {
      value: '',
      fieldName: 'Hex Code',
      errors: {},
      validations: [],
      tab: 0,
    },
    opacity: {
      value: '',
      fieldName: 'Opacity',
      errors: {},
      validations: [],
      tab: 0,
    },
    padding: {
      value: false,
      fieldName: 'Padding',
      errors: {},
      validations: [],
      tab: 0,
    },
    top: {
      value: '10',
      fieldName: 'Top',
      errors: {},
      validations: [],
      tab: 0,
    },
    bottom: {
      value: '10',
      fieldName: 'Bottom',
      errors: {},
      validations: [],
      tab: 0,
    },
    left: {
      value: '10',
      fieldName: 'Left',
      errors: {},
      validations: [],
      tab: 0,
    },
    right: {
      value: '10',
      fieldName: 'Right',
      errors: {},
      validations: [],
      tab: 0,
    },
    hexCode: {
      value: '#82828214',
      fieldName: 'Hex Code',
      errors: {},
      validations: [],
      tab: 0,
    },
  });

  const validate = () => {
    const isValid = formDataValidate(formData, false);
    return isValid;
  };

  useEffect(() => {
    const currFields = { ...formData };
    if (componentObj && Object.keys(componentObj).length > 0) {
      for (let field in currFields) {
        if (componentObj[field] !== undefined) currFields[field].value = componentObj[field];
      }
    }
    setFormData(currFields);
  }, [activeNdx]);

  useEffect(() => {
    onItemChange({
      id: componentId,
      subId: subId || null,
      color: formData.color.value,
      opacity: formData.opacity.value,
      padding: formData.padding.value,
      top: Number(formData.top.value),
      bottom: Number(formData.bottom.value),
      left: Number(formData.left.value),
      right: Number(formData.right.value),
      hexCode: formData.hexCode.value,
      index: componentObj?.index > -1 ? componentObj?.index : -1,
      isValid: validate(),
    });
  }, [formData]);

  return (
    <div className='text-component mt-3'>
      <div className='d-flex justify-content-between'>
        <p className='edit-image'>Edit Divider</p>
        {isRemovable && (
          <p className='edit-image remove-text' onClick={() => onRemoveComponent()}>
            Remove
          </p>
        )}
      </div>
      <div className='mt-3'>
        <BackgroundColor
          formData={formData}
          setFormData={setFormData}
          title='Divider Color'
          fieldKey='color'
        />
      </div>
      <div className='mt-2'>
        <CustomTextField
          item={formData.opacity}
          handleInputChange={(e) => {
            setFormData({ opacity: e });
          }}
          type='number'
          min={0}
          max={1}
          step={0.1}
        />
      </div>
      <div className='mt-3'>
        <PaddingComponent formData={formData} setFormData={setFormData} />
      </div>
      <div className='mt-5'>
        <BackgroundColor
          formData={formData}
          setFormData={setFormData}
          title='Background Color'
          fieldKey='hexCode'
        />
      </div>
    </div>
  );
};

export default DividerComponent;
